import React from "react";

function Heading(props){
	return (
		<h1>{ props.title }</h1>
	)
}

export default Heading;